import { render, staticRenderFns } from "./EditGprs.vue?vue&type=template&id=424808ce&"
import script from "./EditGprs.vue?vue&type=script&lang=js&"
export * from "./EditGprs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports